import React from "react";
import ContactList from "../../../_components/Contacts/ContactList";
import {
    getCustomers, getCustomerKpis, deleteCustomer,
    AREAS, STATUSES, SEARCH_TYPES,
} from "../../../_services/contact.service";

export default function Customers() {
    return (
        <ContactList
            title="Customer List"
            type="Customer"
            fetchList={getCustomers}
            fetchKpis={getCustomerKpis}
            deleteItem={deleteCustomer}
            AREAS={AREAS}
            STATUSES={STATUSES}
            SEARCH_TYPES={SEARCH_TYPES}
        />
    );
}